import graphql from "babel-plugin-relay/macro";
import { useMemo } from "react";
import { useSubscription } from "react-relay";

type Props = {
  bookingId: string;
};

export const AvailableTeeTimesChangedSubscription = ({ bookingId }: Props) => {
  const config = useMemo(() => {
    return {
      variables: {
        bookingId,
      },
      subscription: AvaibleTeeTimesChangedSubscriptionString,
    };
  }, [bookingId]);

  useSubscription(config);

  return null;
};

const AvaibleTeeTimesChangedSubscriptionString = graphql`
  subscription AvailableTeeTimesChangedSubscription($bookingId: ID!) {
    bookingFulfillableSlotChanged(bookingId: $bookingId) {
      booking {
        id
        ... on StandardBooking {
          fullfillableSlots {
            id
            ... on TimeSlot {
              time
              isLocked
              lockedUntil
              availability
              course {
                name
              }
              slotRates: playerRates(
                type: CUSTOMER
                highestPrecedentOnly: true
              ) {
                nineHolePrice: totalGolfPrice(holeCount: NINE)
                eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)
                rate {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
